<template>
  <div v-bind:class="classNames" ref="scrollpane">
    <!-- <CMToolbar class="cm-layout__screenbar cm-toolbar--transparent drawer-screenbar" title="Cookmark"></CMToolbar> -->
    <slot></slot>
  </div>
</template>

<script>
import { SET_DRAWER_VISIBILITY } from '../modules/mutation-types'
import CMToolbar from '../components/CMToolbar'

export default {
  props: {
    theme: {
      type: String,
      default: 'dark'
    }
  },
  components: {
    CMToolbar
  },
  computed: {
    classNames () {
      let classNames = {
        'mui-layout__drawer': true,
        'is-open': this.visibility === 'visible' && this.isTemporary,
        'is-pinned': !this.isTemporary,
        'is-temporary': this.isTemporary
      }
      classNames[`theme--${this.theme}`] = true
      return classNames
    },
    isTemporary () {
      return this.$store.state.device.sizeClass === 'compact'
    },
    visibility () {
      return this.$store.state.app.drawer.visibility
    }
  },
  methods: {
    close () {
      this.$store.commit(SET_DRAWER_VISIBILITY, { visibility: 'hidden' })
    }
  },
  watch: {
    isTemporary (newVal, oldVal) {
      if (oldVal === false) this.close()
    }
  }
}
</script>

<style lang="sass">
@import "../styles/variables.scss"
.mui-layout__drawer, .mui-layout__drawer a
  color: inherit
  font: $textFont
  letter-spacing: $textFontLetterSpacing
.mui-layout__drawer
  position: fixed
  z-index: 0
  top: 0
  left: 0
  bottom: 0
  // padding: constant(safe-area-inset-top) 0 30px 0
  padding: 8px 0 30px 0
  overflow-x: hidden
  overflow-y: auto
  -webkit-overflow-scrolling: touch
  -ms-overflow-style: none
  width: $drawerWidth
  background: $drawerBackground
  // border-right: 1px solid rgba(0, 0, 0, 0.14)
  &.is-temporary
    transform: translateX(0)
    transition: 200ms ease-out transform
    top: 0
    left: - $drawerWidth - 10px
    box-shadow: 2px 1px 10px rgba(0, 0, 0, 0.2)
    // border-right: $layoutBorderDark
    z-index: 1300
    &.is-open
      transform: translateX(260px)
  &.is-pinned
    left: 0
  .mui-list-item
    align-items: center
    font-size: 15px
    padding: 1px 6px
    opacity: .94
    svg
      width: 24px
      height: 24px
      path
        fill: white
    &:hover
      background: #2d3641
      opacity: 1
    &.is-selected
      background: #2d3641
      color: #ffffff
      &:before
        content: ''
        background: #64b2f5
        border-top-right-radius: 2px
        border-bottom-right-radius: 2px
        display: inline-block
        height: calc(100% - 24px)
        left: 0
        position: absolute
        top: 12px
        width: 4px
    .mui-list-item__graphic
      margin-right: 4px
      i
        font-size: 20px
    .mui-list-item__text
      white-space: nowrap
      text-overflow: ellipsis
  .mui-list-divider
    border-color: rgba(255, 255, 255, 0.12)
  &.theme--light
    background: #f5f6f7
    border-right: $layoutBorder
    color: #34363a
    .mui-list-item
      &:hover
        background: #e2e5e8
      &.is-selected
        background: #e2e5e8
        color: #34363a
    .mui-list-divider
      border-color: $borderColor
  &.theme--dark
    color: $drawerColor
</style>



// WEBPACK FOOTER //
// src/components/MUIDrawer.vue